import { WideWidthContainer } from "../../../common/components/layout/Container";
import { ButtonLarge } from "../../../common/components/ui/buttons";
import { locationSelectors } from "../../../common/store/slice/locationSlice";
import { RegionalNamespaces } from "@pslifestyle/common/src/constants/translations";
import {
  QuestionChoiceType,
  QuestionType,
} from "@pslifestyle/common/src/schemas";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Select from "react-select";

interface Props {
  question: QuestionType;
  handleSubmit: (value: string) => void;
}
type SelectOption = {
  label: string;
  value: string;
};
export const Searchable = ({ question, handleSubmit }: Props) => {
  const country = useSelector(locationSelectors.country);
  const [selection, setSelection] = useState<null | SelectOption>(null);
  const { t } = useTranslation([
    RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS,
    "questionnaire",
    "common",
  ]);
  return (
    <WideWidthContainer className="gap-5">
      <Select<SelectOption>
        classNames={{
          control: (state) =>
            state.isFocused ? "!border-green-100 !ring-0" : "!border-green-40",
          option: (state) => {
            if (state.isSelected) {
              return "!bg-green-130";
            }
            if (state.isFocused) {
              return "!bg-green-10";
            }
            return "";
          },
          indicatorSeparator: () => "hidden",
        }}
        id="SearchableAnswer"
        isSearchable
        value={selection}
        placeholder={t("locationSelectPlaceHolder", { ns: "questionnaire" })}
        noOptionsMessage={() => t("noLocationOptions", { ns: "questionnaire" })}
        onChange={(value) => setSelection(value)}
        options={question.choices?.map((choice: QuestionChoiceType) => ({
          label: t(`${choice.choiceTranslationKey}_${country?.code}`, {
            ns: RegionalNamespaces.QUESTION_AND_RECOMMENDATIONS,
          }),
          value: choice.choiceText ?? "",
        }))}
      />
      <ButtonLarge
        theme="goalCTA"
        onClick={() => selection && handleSubmit(selection.value)}
        disabled={selection === null}
      >
        {t(`submit`, { ns: "common" })}
      </ButtonLarge>
    </WideWidthContainer>
  );
};
